/**
 * Image Service
 * Handles image URL construction with base URL
 */
import { API_BASE_URL, CDN_URL as CDN_FROM_CONSTANTS } from '../utils/constants';

const BASE_URL = API_BASE_URL.replace('/api', '');
const CDN_URL = CDN_FROM_CONSTANTS || 'https://cdn.essentick.com';

/**
 * Constructs full image URL from relative path
 * @param {string} imagePath - Relative image path (e.g., /uploads/products/filename.jpg) or full URL
 * @returns {string|null} - Full image URL or null if imagePath is empty
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;

  // Convert to string and trim
  const trimmedPath = String(imagePath).trim();
  
  // If src is already a full URL (starts with http:// or https://), use it directly
  if (trimmedPath.match(/^https?:\/\//i)) {
    return trimmedPath;
  }

  // Use CDN URL if configured
  if (CDN_URL) {
    const cdnBase = CDN_URL.endsWith('/') ? CDN_URL.slice(0, -1) : CDN_URL;
    const normalizedPath = trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`;
    return `${cdnBase}${normalizedPath}`;
  }

  // Fallback to API base URL
  const normalizedPath = trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`;
  return `${BASE_URL}${normalizedPath}`;
};

const imageService = {
  getImageUrl,
};

export default imageService;
